import { FolderClient } from 'api/clients/FolderClient'
import { getHandbook } from 'api/clients/HandbookClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { foldersKeys } from 'hooks/queries/folders/foldersKeys'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import { forceFinderRefresh } from 'redux/actions'
import { setHandbook } from 'redux/actions/handbooks'
import { useRootStore } from 'stores/RootStore'

interface Props {
  folderKey: string
  handbookKey?: string
}

export const useRefresh = ({ folderKey, handbookKey }: Props) => {
  const rootStore = useRootStore()
  const queryClient = useQueryClient()
  const { setCurrentFolder } = useCurrentFolderStore()
  const dispatch = useDispatch()

  const refresh = async () => {
    if (handbookKey)
      getHandbook(handbookKey).then((res) => {
        if (res.type === SUCCESS_RESPONSE_TYPE && res.data.handbook) {
          rootStore.handbooks.add(res.data.handbook)
          dispatch(setHandbook(res.data.handbook))
        }
      })
    FolderClient.getFolder(folderKey).then((res) => {
      if (res.type === SUCCESS_RESPONSE_TYPE && res.data.folder) {
        setCurrentFolder(res.data.folder)
      }
    })
    queryClient.invalidateQueries(foldersKeys.detail(folderKey))
    dispatch(forceFinderRefresh())
  }

  return {
    refresh,
  }
}
